// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-via6 -> weidner-apartment-homes-via6 -> via-six
// Generated: 2026-11-03T23:28:30.849Z
// Counts: 0 design, 20 content, 39 slot group, 2 collection binding, 8 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "faq-intro.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Answers to your questions</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=160/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesgrid.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At Via6, your urban sanctuary blends modern living with vibrant Seattle life. Located on the edge of South Lake Union and Belltown, enjoy proximity to cultural destinations like the Museum of Pop Culture, Seattle Art Museum, and the stunning Olympic Sculpture Park. Dive into the local scene and uncover cherished hidden gems nearby!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.inject_dni_classes": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "right-middle",
    "generatedValue": null,
    "mappedField": null
  },
  "dividerbg.tagline": {
    "overrideType": "VALUE",
    "customValue": "<p>Live your best life at <span data-type=\"field-token\" data-field=\"property_name\"></span>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesgrid.amenity_1_title": {
    "overrideType": "VALUE",
    "customValue": "<p>24-Hour Concierge Services</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitiesgrid.amenity_7_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Walk to Work! At the intersection of Downtown and South Lake Union</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Luxury Apartments Near Downtown &amp; South Lake Union</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "homemap.body": {
    "overrideType": "VALUE",
    "customValue": "<p>At Via6, your urban sanctuary blends modern living with vibrant Seattle life. Nestled in the heart of Belltown, enjoy proximity to cultural destinations like the Museum of Pop Culture, Seattle Art Museum, and the stunning Olympic Sculpture Park. Dive into the local scene and uncover cherished hidden gems nearby!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemapsection.map.config_id": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemapsection.map.javascript_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_engrain_sightmap_url"
  },
  "penthousesection.description": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Gourmet kitchens w/energy-efficient appliances</p></li><li><p>Views of the City and Puget Sound</p></li><li><p>Air conditioning*</p></li><li><p>Walk-in closets*</p></li><li><p>Stone countertops in kitchens and bath spaces</p></li><li><p>Ceramic stovetop ranges</p></li><li><p>Wine fridge</p></li><li><p>Designer backsplash</p></li><li><p>Exclusive views of the city skyline and Puget Sound</p></li><li><p>Granite countertops</p></li><li><p>Double-door refrigerator</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Via6 Apartments redefines what it means to work, live, and play in Seattle. Our pet-friendly community is located in the desirable Belltown neighborhood. It offers an unparalleled lifestyle that seamlessly integrates retail, services, and community allure into a one-of-a-kind living experience. Located on Amazon HQ’s doorstep, you’ll live at the crossroads of one of the most interconnected talent centers in the country, with Meta, Google, Apple, Expedia, and Fred Hutch steps away. Living here puts you close to the best Seattle has to offer, with immediate access to the Westlake Light Rail Station for direct trips to SeaTac Airport, and steps from the Seattle Center Monorail to reach the Space Needle and Climate Pledge Arena in minutes. Whether your priority is mobility, convenience, or comfort, Via6 offers a lifestyle that is truly second to none.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "accessibility-intro.image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "accessibilityhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a13162-14ec-704a-aeb8-7516a9af3be5.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Abstract geometric shapes with blue and brown gradients creating a dynamic light wave effect."
      }
    }
  },
  "amenities-divider-bg.bg_image": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "amenities-intro.image": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "amenitieshero.bg_image": {
    "sourceIndex": 16,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01af-1013-74fa-8fd3-a90878ff8d15.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community lounge area with a pool table, kitchen island with stools, and seating areas."
      }
    }
  },
  "contact-intro.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a13160-fb3a-7094-93d0-bc220e628cfa.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Close-up of a businessman in a dotted shirt making a call in a lively indoor setting with warm lights."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a13160-9bac-75f1-9e1d-e34799a5acb1.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A focused close-up of a female hand holding a smartphone indoors with a soft background."
      }
    }
  },
  "divider-image-bottom.image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "dividerbg.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "floor-plans-intro.image": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "floorplanshero.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": 4,
    "fieldOverrides": null
  },
  "frc-intro.image": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "frchero.bg_image": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "galleryhero.bg_image": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019e6a51-8c2d-7158-9ecc-978bdb2a7790.webp"
      }
    }
  },
  "homeslider.slide_1": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "homeslider.slide_2": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "homeslider.slide_3": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "interactive-map-intro.image": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "neighborhood-intro.image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "penthousehero.bg_image": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "penthousesection.image_1": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "penthousesection.image_2": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "penthousesection.image_3": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "penthousesection.image_4": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "pet-policy-intro-secondary.cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "pet-policy-intro-secondary.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a1315d-b360-724a-b03f-28a46614f31f.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cute poodle sitting with people engrossed in books outside. A warm, relaxed moment."
      }
    }
  },
  "pet-policy-intro.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a1315e-1d03-76b1-84cb-0e582b4abf5f.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Adorable hairy obedient morkie dog with black spots lying on comfortable sofa with cushions in light living room at home"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a1315c-3668-70d5-b733-180ce648def8.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Adorable terrier dog lying on a cozy bed indoors, looking relaxed and content."
      }
    }
  },
  "privacy-policy-intro.image": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "privacypolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a13162-14ec-704a-aeb8-7516a9af3be5.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Abstract geometric shapes with blue and brown gradients creating a dynamic light wave effect."
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "sitemap-intro.image": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "sitemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/01a13162-14ec-704a-aeb8-7516a9af3be5.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Abstract geometric shapes with blue and brown gradients creating a dynamic light wave effect."
      }
    }
  },
  "virtual-tour-intro.image": {
    "sourceIndex": 21,
    "fieldOverrides": null
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449166934/019d01ad-731c-7459-99ff-1f4933a130ce.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern bedroom with a king-size bed, orange headboard, nightstands, and a walk-in closet."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslistinterior.items": {
    "limit": null,
    "hiddenIds": [
      "ec_aec898bff85d21c4c37f28df",
      "ec_b9c58b7016c8715503f3aaf7",
      "ec_555a51a49c6c8815580bc366",
      "ec_a823751fe545602ea970f558",
      "ec_15ed6b23ef3e325b176aed55",
      "ec_a4fca14ae79a90495118b303",
      "ec_3e5a356b068c47e9d931943e",
      "ec_344209f7c0fd48630074f12b",
      "ec_7a2e8899970671a6da69b962",
      "ec_df0e49eb75de5be0ac029143",
      "ec_ca8fc9a0724d1919dffd40e3",
      "ec_76c5f9223380e575828309f8",
      "ec_d9c3dc1127c921bdac07d9d4",
      "ec_f827c574364abd6329606aed",
      "ec_85098063c7753fcae0125cf1",
      "ec_e1e27dfebb56a71bd82a1bb5",
      "ec_ec50800050a30365630fc4da",
      "ec_8e5f32f3bf44e100e63399ba",
      "ec_f073b94c97a0c0a98e7ec66b",
      "ec_6952e9e5e37c2fb05deffd77",
      "ec_82fa49607a0a32b16e049b3b",
      "ec_0fb71cc4b03f8055d417e170",
      "ec_e533c6e8826a9dc1886b0038",
      "ec_4a9058a2a05145f375a3eca5",
      "ec_c4e552763c5f5616f5c11be0",
      "ec_0e088a0e44596f27dea19635",
      "ec_d21b8380f319f0e1bb2b65e1",
      "ec_ba6acedb89c2f9b1877b17e9",
      "ec_9a54f7fefca39299e07baeb6",
      "ec_bbdfe47f8fa746efa21a1d42",
      "ec_c4c7942b3a989050f5cb8ec8",
      "ec_1de3416b7d4150499d91eb91",
      "ec_4d0d87061df0bb7bac4036f8",
      "ec_8e7446c047ab272e27ee0db6",
      "ec_9d0d91854e390291dec12bde",
      "ec_3f17a7533313829c877cc610",
      "ec_e8908e463dcc398a7cc83671",
      "ec_204689e00392504af3010aab",
      "ec_a9684aa56e72ab4df3d7200d",
      "ec_70d61f7e732f12f1671eda62",
      "ec_0ac0a7144bb0c5c49a29dc40",
      "ec_b0c50ead34ad61f331d7809d",
      "ec_c6c0f94679034e5791f86760",
      "ec_8fb3d7d03daead702057c09f",
      "ec_82d66c813a1b8ac0ca3c402c",
      "ec_bc726f3778f880415b78bdd8",
      "ec_4ea7b158c03841a4ef849ee7",
      "ec_1a7f13fd09bf826e5376fce5",
      "ec_e7a223c701ead049bf95c39d",
      "ec_7ee8e9f56a9cf10f648b127c",
      "ec_00cdd3a5d454cce034a69054",
      "ec_f90ff515b933c5d044c80d4c",
      "ec_afd62d659c9e0fabe1a54848",
      "ec_d80f78faf809ac65f7d2a491",
      "ec_bceff80b35f1800a72c38d22",
      "ec_8cff69d528b292a26d860fa6",
      "ec_51dc444d1bd7fdb712a64486",
      "ec_3a564cac0256a667de1366b7",
      "ec_ca34e4ad137f554cdbb87f0c",
      "ec_73a735265fbe01b79cca2cdd",
      "ec_f42f4f933c2ef76de714a44f",
      "ec_53e1e8186066cede8178bf65",
      "ec_86f4266ffae5022baa5bb299",
      "ec_41e71a6b978aaa0c4ca88601",
      "ec_f3e2aff8ff7cdacd49d6e3cb",
      "ec_84ad3a1b2eded513c6736dae",
      "ec_b45aab2cc0af0c407e64c140",
      "ec_777435d808f7f31d1ed19850",
      "ec_904845abac40270a455bb334",
      "ec_fd559f9d65b9d2c0bed1b6c9",
      "ec_f9024252de0fafabaff86ba4",
      "ec_c168e49f42c238634293d7c3",
      "ec_795388cccbacbb84a5cf5864",
      "ec_601423e25182cf09f3e97fcd",
      "ec_9ede95a159c62e63a022a8ca",
      "ec_6df45765cef2d0c7a0446208",
      "ec_4447b177af91539e14cdd925"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      8,
      10,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      37,
      36,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      52,
      51,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61,
      62,
      63,
      64,
      65,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      75,
      76,
      77,
      78,
      79,
      80,
      81,
      82,
      83,
      84,
      85,
      86,
      87,
      88
    ],
    "ordering": null,
    "customItems": null
  },
  "gallerytabs.community_images": {
    "limit": null,
    "hiddenIds": [
      "ec_a280bf63ca34c4f5c184f0a3"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      7
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
